export default __webpack_public_path__ + "79bfd65b54cd5fadb83db99cde7eff1f.png";